import React from 'react';
import { Sparkles, Twitter, Linkedin, Mail } from 'lucide-react';
import './Footer.css';

function Footer() {
  return (
    <footer className='footer'>
      <div className='footer-container'>
        {/* Brand Section */}
        <div className='footer-brand'>
          <div className='footer-logo'>
            <Sparkles size={28} />
            <span>Story Engine</span>
          </div>
          <p className='footer-tagline'>
            AI-powered LinkedIn content creation that helps professionals build
            their personal brand effortlessly.
          </p>

          {/* Social Links */}
          <div className='footer-social'>
            <a
              href='https://twitter.com'
              target='_blank'
              rel='noopener noreferrer'
              className='social-link'
            >
              <Twitter size={20} />
            </a>
            <a
              href='https://linkedin.com'
              target='_blank'
              rel='noopener noreferrer'
              className='social-link'
            >
              <Linkedin size={20} />
            </a>
            <a href='mailto:yourstory@ztoryengine.com' className='social-link'>
              <Mail size={20} />
            </a>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className='footer-links'>
          <div className='footer-column'>
            <h4>Product</h4>
            <ul>
              <li>
                <a href='#the-system'>Features</a>
              </li>
              <li>
                <a href='#how-it-works'>How It Works</a>
              </li>
              <li>
                <a href='#signup'>Get Early Access</a>
              </li>
            </ul>
          </div>

          {/* <div className='footer-column'>
            <h4>Legal</h4>
            <ul>
              <li>
                <a href='#privacy'>Privacy Policy</a>
              </li>
              <li>
                <a href='#terms'>Terms of Service</a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>

      {/* Copyright */}
      <div className='footer-bottom'>
        <p>© 2025 Story Engine. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
